<template>
  <div id="opening">
    <h2 class="is-size-5 has-text-primary modaltitle" style="margin-top: 0">Sparing</h2>
    <table class="printblock-table">
      <tr>
        <td>Qr Code</td>
        <editable :editing="false" type="number" v-model.number="openingData.tagId"></editable>
      </tr>
      <tr>
        <td>Id op tekening</td>
        <editable :editing="editMode" type="number" v-model.number="openingData.idOnDrawing"></editable>
      </tr>
      <tr>
        <td>Kamer</td>
        <editable :editing="editMode" v-model="openingData.room" />
      </tr>
      <tr>
        <td>BSC</td>
        <editable
          :editing="editMode"
          v-model="openingData.wallFloorAssembly"
          type="select"
          :dataSelect="bsc"
          :iconBool="true"
        />
      </tr>
      <tr>
        <td>Brandwerendheid</td>
        <editable
          :editing="editMode"
          v-model="openingData.fireRating"
          type="select"
          item="fireRating"
          :dataSelect="fireRating"
          :iconBool="true"
        />
      </tr>
      <tr v-if="admin">
        <td>Montagetijd</td>
        <editable :editing="editMode" type="number" label="Montagetijd" v-model.number="openingData.assemblyTime" />
      </tr>
      <tr>
        <td>Opmerking</td>
        <editable :editing="editMode" v-model="openingData.comment" />
      </tr>
      <tr>
        <td>Gebruiker</td>
        <td-user v-if="editMode == false" :username="openingData.dbUser" />
        <!-- <td v-if="editMode == false">{{ openingData.dbUser | stripEmail }}</td> -->
        <editable v-else :editing="editMode" v-model="openingData.dbUser" />
      </tr>
      <tr>
        <td>Datum</td>
        <editable :editing="false" v-model="openingData.dbDate" />
      </tr>

      <!--| prettyDate -->
    </table>
  </div>
</template>

<script>
import editable from '@/components/Projects/editable.vue'
import bigData from './bigData.js'
import TdUser from '../General/TdUser.vue'
export default {
  // filters: {
  //   stripEmail: function (value) {
  //     if (!value) return ''
  //     if (!value.includes('@')) return value

  //     const i = value.indexOf('@')
  //     return value.substring(0, i)
  //   }
  // },
  components: {
    editable,
    TdUser
  },
  props: {
    openingData: {
      type: Object
    },
    editMode: {
      type: Boolean,
      default: false
    },
    admin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bsc: [
        { id: 1, name: 'Dubbele Wand', code: 'DoubleWall', icon: '01_dw.svg' },
        { id: 2, name: 'Enkele Wand', code: 'SingleWall', icon: '02_ew.svg' },
        { id: 3, name: 'Schacht Wand', code: 'OneSidedWall', icon: '03_sw.svg' },
        { id: 4, name: 'Plafond', code: 'Ceiling', icon: '04_ple.svg' },
        { id: 5, name: 'Vloer', code: 'Floor', icon: '05_vl.svg' },
        { id: 6, name: 'Plafond 2-zijdig', code: 'DoubleCeiling', icon: '06_pld.svg' }
      ],
      fireRating: [
        { id: 1, name: 'EI30', code: 'EI30', icon: 'clock-regular.svg' },
        { id: 2, name: 'EI60', code: 'EI60', icon: 'clock-regular.svg' },
        { id: 3, name: 'EI120', code: 'EI120', icon: 'clock-regular.svg' },
        { id: 4, name: 'EI180', code: 'EI180', icon: 'clock-regular.svg' },
        { id: 5, name: 'EI240', code: 'EI240', icon: 'clock-regular.svg' },
        { id: 6, name: 'EI300', code: 'EI300', icon: 'clock-regular.svg' },
        { id: 7, name: 'EI360', code: 'EI360', icon: 'clock-regular.svg' }
      ]
    }
  },

  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/Projects/OpeningInfo.vue